const STORAGE_KEY = 'jdPreviewReturnContext';

export const JD_PREVIEW_FALLBACK_PATH = '/existing-positions';

function persistJdPreviewReturnContext(returnTo) {
  if (!returnTo?.pathname) return;

  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(returnTo));
  } catch {
    // Ignore storage failures and rely on in-memory route state.
  }
}

export function buildJdPreviewNavigationState({ returnTo, ...extraState } = {}) {
  const resolvedReturnTo = returnTo?.pathname
    ? returnTo
    : { pathname: JD_PREVIEW_FALLBACK_PATH };

  persistJdPreviewReturnContext(resolvedReturnTo);

  return {
    ...extraState,
    returnTo: resolvedReturnTo,
  };
}

export function getPersistedJdPreviewReturnContext() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function resolveJdPreviewReturnTarget(location) {
  const fromState = location?.state?.returnTo;
  if (fromState?.pathname) {
    return fromState;
  }

  const persisted = getPersistedJdPreviewReturnContext();
  if (persisted?.pathname) {
    return persisted;
  }

  if (location?.state?.fromOpenPositions) {
    return {
      pathname: '/open-positions',
      state: {
        fromJdPreview: true,
        positionId: location.state.positionId,
        positionName: location.state.positionName || '',
        clientName: location.state.clientName || '',
        jobCode: location.state.jobCode || '',
        jdType: location.state.jdType || null,
        jdContent: location.state.jdContent || '',
        selectedCeipalJob: location.state.selectedCeipalJob || null,
        structuredData: location.state.structuredData || null,
      },
    };
  }

  return { pathname: JD_PREVIEW_FALLBACK_PATH };
}
